import { useEffect } from 'react'

interface UseLayerMappingsProps {
  currentFloor: string | null
  projectId: number | null
  loadMappings: (floorId: string) => Promise<void>
}

/**
 * Hook to load layer mappings when the current floor changes.
 * Layer mappings define how CSV layers map to object types.
 */
export function useLayerMappings({
  currentFloor,
  projectId,
  loadMappings,
}: UseLayerMappingsProps): void {
  useEffect(() => {
    if (currentFloor && projectId) {

      loadMappings(currentFloor).catch((error) => {
      })
    }
  }, [currentFloor, projectId, loadMappings])
}
